module.exports = __webpack_public_path__ + "static/media/categories-empty.f0c4c7b6.svg";